import { getSubscriptionTypeString, getSubscriptionPlanString } from '~/services/subscriptions';

/** @type {import('@nuxt/types').Plugin} */
export default ({ i18n }, inject) => {
    /** @type {import('@nuxt/types').Context['$account']} */
    const plugin = {
        formatSubscriptionName(tier, plan, options) {
            const { countryCode, isChild } = options;

            if (isChild) {
                if (tier) {
                    return `${i18n.t(getSubscriptionTypeString(tier, countryCode))}`;
                } else {
                    console.error('tier is required for formatting child subscription name');
                    return '';
                }
            }
            if (tier && plan) {
                return `${i18n.t(getSubscriptionTypeString(tier, countryCode))} (${i18n.t(getSubscriptionPlanString(plan))})`;
            }
            if (plan) {
                return `${i18n.t(getSubscriptionPlanString(plan))}`;
            }
            if (tier) {
                return `${i18n.t(getSubscriptionTypeString(tier, countryCode))}`;
            }
            return 'TIDAL';
        },
    };

    inject('account', plugin);
};
